import React from 'react'
import { useWillPipe } from '@morningtrain/react-pipelines'
import useAccordion from 'support/utilities/accordions/hooks/use-accordion'

export default function ToggleAccordionOnPipe ({ name }) {
  const accordion = useAccordion()

  useWillPipe(payload => {
    accordion.toggle(name)

    return payload
  }, [accordion, name])

  return null
}
